import { makeStyles } from '@material-ui/core'

export const useIndexStyles = makeStyles(() => ({
  tabRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  buttonGroupBox: {
    display: 'flex',
    gap: '12px',
    marginLeft: '16px',
    flexShrink: 0
  },
  modalHeader: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px'
  }
}))
